import React from 'react';
import PropTypes from 'prop-types';
import styles from './Disclaimer.module.scss';

const Disclaimer = ({ termsAccepted, handleTermsAccept }) => {
  return (
    <form>
      <label htmlFor="terms-checkbox">
        <div className={styles['flex-container']}>
          <div>
            <input
              className={`terms-checkbox ${(termsAccepted.touched && !termsAccepted.valid) && 'terms-checkbox-error'}`}
              type="checkbox"
              name="termsAccepted"
              checked={termsAccepted.value}
              onChange={handleTermsAccept}
              id="terms-checkbox"
            />
          </div>
          <div className={styles.text}>
            By purchasing a press release package, you agree to our
            {' '}
            <a href="https://www.industrydive.com/terms-of-use/" target="_blank" rel="noreferrer">Terms of Use</a> and
            {' '}
            <a href="https://www.industrydive.com/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>.
            <span className={styles.asterisk}>*</span>
            {termsAccepted.touched && termsAccepted.errors.length > 0 && (
              <div className={styles.error}>{termsAccepted.errors[0]}</div>
            )}
          </div>
        </div>
      </label>
    </form>
  );
};

Disclaimer.propTypes = {
  termsAccepted: PropTypes.shape({
    value: PropTypes.bool,
    touched: PropTypes.bool,
    valid: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  handleTermsAccept: PropTypes.func.isRequired,
};

export default Disclaimer;
